import { Button, Modal } from 'antd';
import React, { FC } from 'react';
import { IconWarning } from 'shared/ui/form/icons/IconWarning';
import { Link } from 'react-router-dom';
import style from './index.module.scss';

type TProps = {
  open: boolean;
  onQuit: () => void;
  onStay: () => void;
};

const ModalCancelSubmit: FC<TProps> = ({ onStay, onQuit, open }) => {
  return (
    <Modal open={open} onCancel={onStay} footer={null}>
      <div className={style.content}>
        <IconWarning />
        <h3 style={{ marginTop: 16 }}>Вы действительно хотите выйти?</h3>
        <p>Все введенные данные будут удалены!</p>
        <div className={style.buttons}>
          <Button onClick={onQuit}>Выйти</Button>
          <Button onClick={onStay} type="primary">
            Остаться
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalCancelSubmit;
